import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetAlarmIdices } from "../alarmUXSlice";
import { PageIndex } from "../../../models";
import { setAlarmIndexThunk } from "../thunks/loadAlarms";

export const useAlarmIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>(
    (s) => s.ux.surveillance.alarms.index
  );

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setAlarmIndexThunk(index)),
    [dispatch]
  );
  const dispatchResetIndex = React.useCallback(
    () => dispatch(resetAlarmIdices()),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex,
    typeof dispatchResetIndex
  ];
};
